import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-upload-to-relay-alert',
  templateUrl: './upload-to-relay-alert.component.html',
  styleUrls: ['./upload-to-relay-alert.component.sass'],
  imports: [ButtonModule],
})
export class UploadToRelayAlertComponent {
  constructor(
    public dialogRef: DynamicDialogRef<UploadToRelayAlertComponent>
  ) {}

  confirmUploadToRelay() {
    this.dialogRef.close({
      isUploadedToRelay: true,
    });
  }
}
